import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { injectIntl } from "react-intl";
import { Loading } from "@ebsco-ui/ebsco-ui";
import {
  fetchGdprPrompt,
  getGdprPromptLoading,
  getGdprPromptId,
  getGdprResponseLoading,
  fetchGdprResponse,
  getGdprResponseDate
} from "../../store/gdpr";
import {
  fetchDataReportListLoading,
  hasAnyDataReports,
  hasPendingDataReports,
  fetchDataReportList
} from "../../store/data-report";
import getIsCoppa from "../../store/coppa";
import sharedMessages from "../../../shared-messages";

function withGdprResponseData(WrappedComponent) {
  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || "Component";
  }

  return class extends Component {
    static displayName = `withGdprResponseData(${getDisplayName(
      WrappedComponent
    )})`;

    state = {
      isLoadingIndicatorEnabled: true
    };

    async componentDidMount() {
      const {
        promptId,
        responseDate,
        fetchGdprPrompt,
        fetchGdprResponse,
        hasAnyReports,
        hasPendingReports,
        fetchDataReportList,
        isCoppa
      } = this.props;

      if (!promptId) {
        await fetchGdprPrompt();
        if (!isCoppa) {
          fetchGdprResponse();
        }
      }

      if (promptId && !responseDate && !isCoppa) {
        fetchGdprResponse();
      }

      if ((!hasAnyReports || hasPendingReports) && !isCoppa) {
        fetchDataReportList();
      }
    }

    componentDidUpdate(prevProps) {
      const { isLoading } = this.props;

      if (prevProps.isLoading && !isLoading) {
        this.setState({ isLoadingIndicatorEnabled: false });
      }
    }

    render() {
      const {
        error,
        intl: { formatMessage },
        isLoading,
        ...passThroughProps
      } = this.props;
      const { isLoadingIndicatorEnabled } = this.state;
      return isLoading && isLoadingIndicatorEnabled ? (
        <Loading loadingMessage={formatMessage(sharedMessages.loading)} />
      ) : (
        <WrappedComponent {...passThroughProps} />
      );
    }
  };
}

const mapStateToProps = state => ({
  isLoading:
    getGdprPromptLoading(state) ||
    (getGdprResponseLoading(state) && !getIsCoppa(state)) ||
    fetchDataReportListLoading(state),
  promptId: getGdprPromptId(state),
  responseDate: getGdprResponseDate(state),
  hasAnyReports: hasAnyDataReports(state),
  hasPendingReports: hasPendingDataReports(state),
  isCoppa: getIsCoppa(state)
});

const mapDispatchToProps = {
  fetchGdprPrompt,
  fetchGdprResponse,
  fetchDataReportList
};

export { withGdprResponseData };
export default compose(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
  withGdprResponseData
);
